import { http } from "~/services/http";
import useSWR from "swr";

export const useFetchHome = () => {
  const { data: status, error, isLoading } = useSWR("/api/home", http.get);

  return { status, isLoading, error };
};
